export { default } from "./tooltip";
export type { IProps as ITooltipProps } from "./tooltip.types";
